import { CurrentUser } from '@/_interfaces/CurrentUser'

export const alertUnitDeactivate = (vm) => {
    const currentUser = vm.$store.state.authentication?.currentUser as CurrentUser

    if (currentUser) {
        const isUnitDeactivate = currentUser.is_active === false

        if (isUnitDeactivate) {
            const snackbar = vm.$buefy.snackbar.open({
                message: vm.$t('messages.unit_deactivate'),
                type: 'is-warning',
                position: 'is-top',
                actionText: vm.$t('label.ok'),
                queue: false
            })

            setTimeout(() => {
                snackbar.close()
            }, 3000)

            return true
        }

        return false
    }

    return false
}
